import { IonButton, IonButtons, IonContent, IonFab, IonFabButton, IonHeader, IonIcon, IonLoading, IonModal, IonPage, IonReorder, IonReorderGroup, IonSelect, IonSelectOption, IonTitle, IonToast, ItemReorderEventDetail, useIonViewDidEnter } from '@ionic/react';
import { add, arrowBack, calendarOutline, informationCircleOutline, reorderTwo, timeOutline, trash } from 'ionicons/icons';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router';
import { useModalAlert as useIonAlert } from '../../../../../components/Modal/ModalAlert';
import ModalHeader from '../../../../../components/Modal/ModalHeader';
import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import OnboardingContextBanner from '../../../../../components/Onboarding/OnboardingContextBanner';
import { MessageContext } from '../../../../../contexts/MessageContext';
import { OnboardingContext } from '../../../../../contexts/OnboardingContext';
import '../../../../../theme/reorder.css';
import { empresaConfiguracoesAlterar, onboardingAtualizarEtapa, ordernarItemHorariosEmpresa, removerHorariosEmpresa, requestService } from '../../../../../Utils/Services';
import "./Horarios.css";

type Props = {
  onDismiss: () => void;
};

const Horarios: React.FC<Props> = (props: Props) => {

  const history = useHistory<any>();
  const [showLoading, setShowLoading] = useState(false);
  const [listaHorarios, setListaHorarios] = useState<any>([]);

  const [showDetalhes, setShowDetalhes] = useState(false);
  const [index, setIndex] = useState("");
  const [nome, setNome] = useState("");

  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");


  const { loja, setLoja } = useContext(MessageContext);
  const { onboardingData, setOnboardingData } = useContext(OnboardingContext);
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
  const podeOrdenar = acessos?.configuracoes === 'edicao';
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);


  const [tipo, setHorarios] = useState('');

  const [idOpenHour, setIdOpenHour] = useState<any>();
  const [dayOfWeekOpenHour, setDayOfWeekOpenHour] = useState<any>();
  const [startOpenHour, setStartOpenHour] = useState<any>();
  const [endOpenHour, setEndOpenHour] = useState<any>();
  const [durationOpenHour, setDurationOpenHour] = useState<any>();


  const [mostartAlerta] = useIonAlert();

  const { dadosEmpresa, setDadosEmpresa } = useContext(MessageContext);

  useIonViewDidEnter(() => {
    setEsconderMenu(true);
    setNomeMenu("");
    setListaHorarios(dadosEmpresa.horarios || []);
  });

  function deletarHorarios(indice: any) {

    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") { token = tkn; }

    const delHorarios = async () => {
      setShowLoading(true);
      try {
        const resp = await fetch(removerHorariosEmpresa.url.replace("{id}", loja.replace(/#/g, "%23")),
          {
            method: removerHorariosEmpresa.method,
            headers: [
              ["token", token]
            ],
            body: JSON.stringify({ 'index': indice }),
            credentials: 'include'
          });
        const response = await resp.json();

        if (response) {
          setListaHorarios(response.message.Attributes.horarios || []);
          dadosEmpresa.horarios = response.message.Attributes.horarios;
          setDadosEmpresa(dadosEmpresa);


          console.log("retorno", response);
          setTextToast("Horário removido com sucesso.");
          setShowToast(true);
        }
        // carregarConta();
      } catch (err) {
        console.log(err);
        setTextToast("Ocorreu um erro ao remover.");
        setShowToast(true);
      } finally {
        setShowLoading(false);
      }
    }

    delHorarios();

  }

  function handleReorder(event: CustomEvent<ItemReorderEventDetail>) {
    if (!podeOrdenar || showLoading || event.detail.from === event.detail.to) {
      event.detail.complete(false);
      return;
    }

    // Before complete is called with the items they will remain in the
    // order before the drag
    //console.log('Before complete', listaItemCatalogoProdutos);

    // Finish the reorder and position the item in the DOM based on
    // where the gesture ended. Update the items variable to the
    // new order of items
    setListaHorarios(event.detail.complete(listaHorarios));

    // After complete is called the items will be in the new order
    //console.log('After complete', listaItemCatalogoProdutos);


    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") { token = tkn; }

    const ordItemHorarios = async () => {
      const resp = await fetch(ordernarItemHorariosEmpresa.url.replace("{id}", loja.replace(/#/g, "%23")),
        {
          method: ordernarItemHorariosEmpresa.method,
          headers: [
            ["token", token]
          ],
          body: JSON.stringify({ 'horarios': listaHorarios }),
          credentials: 'include'
        });
      const retorno = await resp.json();
      console.log("retorno ordenar", retorno);

      if (retorno && retorno.Item?.Attributes) {
        setTextToast("Ordenação alterada com sucesso.");
        setShowToast(true);
        setListaHorarios(retorno.Item?.Attributes?.horarios || []);
        dadosEmpresa.horarios = retorno.Item?.Attributes?.horarios;
        setDadosEmpresa(dadosEmpresa);

      }
      else {
        setTextToast("Ocorreu um erro ao ordernar.");
        setShowToast(true);
      }
    }

    ordItemHorarios();

  }


  const loadHorarios = () => {


    if (listaHorarios == undefined) return;

    if (listaHorarios.length === 0) {
      return (
        <div className="horarios-empty">
          <span className="horarios-empty-icon"><IonIcon icon={calendarOutline} aria-hidden="true" /></span>
          <h2>Nenhum horário cadastrado</h2>
          <p>Cadastre os dias e horários de funcionamento da sua loja.</p>
        </div>
      );
    }




    return (
      <>
        <IonReorderGroup role="rowgroup" disabled={!podeOrdenar || showLoading} onIonItemReorder={handleReorder}>
          {listaHorarios.map((value: any, index: any) => {

            // Mapeamento dos dias da semana para português
            const daysOfWeekMap: { [key: string]: string } = {
              "MONDAY": "Segunda-feira",
              "TUESDAY": "Terça-feira",
              "WEDNESDAY": "Quarta-feira",
              "THURSDAY": "Quinta-feira",
              "FRIDAY": "Sexta-feira",
              "SATURDAY": "Sábado",
              "SUNDAY": "Domingo"
            };

            // Calcula o horário de término
            const calculateEndTime = (start: string, duration: number) => {
              const [startHour, startMinute] = start.split(':').map(Number);
              const startTotalMinutes = startHour * 60 + startMinute;
              const endTotalMinutes = startTotalMinutes + duration;

              const endHour = Math.floor(endTotalMinutes / 60);
              const endMinute = endTotalMinutes % 60;

              const endHourStr = endHour < 10 ? `0${endHour}` : `${endHour}`;
              const endMinuteStr = endMinute < 10 ? `0${endMinute}` : `${endMinute}`;

              return `${endHourStr}:${endMinuteStr}:00`;
            };

            // Traduz o dia da semana
            const translatedDay = daysOfWeekMap[value.dayOfWeek] || value.dayOfWeek;
            const endTime = calculateEndTime(value.start, value.duration);

            const editarHorario = () => {
              if (!podeOrdenar || showLoading) return;
              setIndex(index);
              setIdOpenHour(value.id);
              setDayOfWeekOpenHour(value.dayOfWeek);
              setStartOpenHour(value.start);
              setDurationOpenHour(value.duration);
              setEndOpenHour(endTime);
              setShowDetalhes(true);
            };

            return (
              <div className={`horarios-table-row ${podeOrdenar ? 'horarios-editable-row' : ''}`} role="row" key={index}
                tabIndex={podeOrdenar && !showLoading ? 0 : undefined}
                aria-label={podeOrdenar ? `Editar horário de ${translatedDay}, ${value.start.slice(0, 5)}–${endTime.slice(0, 5)}` : undefined}
                onClick={editarHorario}
                onKeyDown={(event) => {
                  if (event.target === event.currentTarget && (event.key === 'Enter' || event.key === ' ')) {
                    event.preventDefault();
                    editarHorario();
                  }
                }}>
                {podeOrdenar && <div className="horarios-order-cell" role="cell" onClick={(event) => event.stopPropagation()}>
                  <IonReorder className="list-reorder-handle" aria-label={`Ordenar horário de ${translatedDay}`}>
                    <IonIcon icon={reorderTwo} aria-hidden="true" />
                  </IonReorder>
                </div>}
                <div className="horarios-table-cell horarios-day-cell" role="cell"><span className="horarios-cell-label" aria-hidden="true">Dia da semana</span><strong>{translatedDay}</strong><span className="horarios-mobile-range">{value.start.slice(0, 5)}–{endTime.slice(0, 5)}</span></div>
                <div className="horarios-table-cell horarios-time-cell" role="cell"><span className="horarios-cell-label" aria-hidden="true">Início</span><span>{value.start.slice(0, 5)}</span></div>
                <div className="horarios-table-cell horarios-time-cell" role="cell"><span className="horarios-cell-label" aria-hidden="true">Término</span><span>{endTime.slice(0, 5)}</span></div>
                {podeOrdenar && <div className="horarios-table-cell horarios-row-actions" role="cell" onClick={(event) => event.stopPropagation()}>
                  <span className="horarios-cell-label" aria-hidden="true">Ações</span>
                    <IonButton fill="clear" className="horarios-delete" aria-label={`Remover horário de ${translatedDay}`} hidden={acessos?.configuracoes != 'edicao'}
                      onClick={() => {
                        mostartAlerta({
                          backdropDismiss: false,
                          header: 'Remover item',
                          message: 'Deseja <strong>remover</strong>?',
                          buttons: [
                            {
                              text: 'Cancelar',
                              role: 'cancel',
                            },
                            {
                              text: 'Confirmar',
                              cssClass: 'primary',
                              handler: () => {
                                deletarHorarios(index);
                              }
                            }
                          ],
                          onDidDismiss: (e) => console.log('did dismiss'),
                        })
                      }}>
                      <IonIcon slot="icon-only" icon={trash} aria-hidden="true" />
                    </IonButton>



                </div>}
              </div>
            )
          })}
        </IonReorderGroup>
      </>
    );
  }


  const validate = () => {
    let isValid = true;
    let errors: Array<{ message: string }> = [];

    if (!dayOfWeekOpenHour) {
      isValid = false;
      errors.push({ message: `Dia da semana não pode estar vazio.` });
    }

    if (!startOpenHour) {
      isValid = false;
      errors.push({ message: `Hora de início não pode estar vazio.` });
    }

    if (!endOpenHour) {
      isValid = false;
      errors.push({ message: `Hora de término não pode estar vazio.` });
    }

    if (!durationOpenHour || durationOpenHour <= 0) {
      isValid = false;
      errors.push({ message: `Duração inválida.` });
    }

    return { isValid, errors };
  };


  async function salvar() {

    const { isValid, errors } = validate();

    if (!isValid && errors.length > 0) {
      console.log('Erros de validação:', errors);

      // Mapeia o array de erros e retorna um array de strings para o IonToast
      const errorMessages: any = errors.map((error) => `${error.message}`);
      setTextToast(errorMessages.join('<br>'));
      setShowToast(true);
      return;
    }

    const objectRequest = {
      index: index,
      horarios: {
        dayOfWeek: dayOfWeekOpenHour,
        start: startOpenHour,
        duration: durationOpenHour, // Envia a duração calculada para a API
      }
    }
    console.log("objectRequest", objectRequest);

    let id = loja;

    console.log("id", id);

    setShowLoading(true);

    await requestService(
      empresaConfiguracoesAlterar.url.replace("{id}", id.replaceAll("#", "%23")).concat("?horarios=sim"),
      {
        method: empresaConfiguracoesAlterar.method,
        body: JSON.stringify(objectRequest),
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
      history,
      (response: any) => {
        console.log(response);
        if (response) {
          setTextToast("Cadastro realizado com sucesso.");
          setShowToast(true);

          console.log("response", response);

          setListaHorarios(response.message.Attributes.horarios || []);
          dadosEmpresa.horarios = response.message.Attributes.horarios;
          setDadosEmpresa(dadosEmpresa);

          // Marcar etapa do onboarding como concluída
          if (onboardingData && !onboardingData.onboarding_concluido) {
            const urlOnb = onboardingAtualizarEtapa.url
              .replace("{empresa_id}", onboardingData.empresa_id.replaceAll("#", "%23"));
            requestService(urlOnb, {
              method: onboardingAtualizarEtapa.method,
              body: JSON.stringify({ etapa_id: 'horarios', status: 'concluido' }),
              headers: [["token", window.localStorage.getItem("token")]],
              credentials: 'include'
            }, history, (r: any) => { if (r) setOnboardingData(r); }, () => { });
          }

          //carregarConta();
          setShowDetalhes(false);

        } else if (response.status === 400) {
          console.log(response);
          setTextToast("Ocorreu um erro ao efetuar o cadastro.");
          setShowToast(true);

        }
        setShowLoading(false);
      },
      (error: any) => {
        console.log(error);
        setTextToast("Ocorreu um erro ao efetuar o cadastro.");
        setShowToast(true);
        setShowLoading(false);
      })


  }

  const generateTimeOptions2359 = () => {
    const times = [];
    let hour = 0;
    let minute = 0;

    // Gera opções de hora no formato HH:mm:ss, de 30 em 30 minutos
    for (let i = 0; i < 48; i++) {
      const hourStr = hour < 10 ? `0${hour}` : `${hour}`;
      const minuteStr = minute < 10 ? `0${minute}` : `${minute}`;
      times.push(`${hourStr}:${minuteStr}:00`);

      // Incrementa os minutos em 30
      minute += 30;
      if (minute === 60) {
        minute = 0;
        hour += 1;
      }
    }

    // Adiciona a última opção de horário como "23:59"
    times.push("23:59:00");

    return times;
  };

  const generateEndTimeOptions = () => {
    if (!startOpenHour) return [];

    const [startHour, startMinute] = startOpenHour.split(':').map(Number);
    const startTotalMinutes = startHour * 60 + startMinute;

    const times = [];
    let currentMinutes = startTotalMinutes + 30; // Mínimo 30 minutos

    while (currentMinutes <= 1439) {
      const hour = Math.floor(currentMinutes / 60);
      const minute = currentMinutes % 60;
      const hourStr = hour < 10 ? `0${hour}` : `${hour}`;
      const minuteStr = minute < 10 ? `0${minute}` : `${minute}`;
      times.push(`${hourStr}:${minuteStr}:00`);
      currentMinutes += 30;
    }

    // Adiciona 23:59 se não estiver na lista
    if (!times.includes("23:59:00")) {
      times.push("23:59:00");
    }

    return times;
  };

  const handleEndTimeChange = (endTime: string) => {
    setEndOpenHour(endTime);

    if (startOpenHour) {
      const [startHour, startMinute] = startOpenHour.split(':').map(Number);
      const [endHour, endMinute] = endTime.split(':').map(Number);

      const startTotalMinutes = startHour * 60 + startMinute;
      const endTotalMinutes = endHour * 60 + endMinute;

      const duration = endTotalMinutes - startTotalMinutes;

      if (duration <= 0) {
        setTextToast("A hora de término deve ser posterior à hora de início.");
        setShowToast(true);
        setDurationOpenHour(0);
      } else {
        setDurationOpenHour(duration);
      }
    }
  };

  const handleStartTimeChange = (startTime: string) => {
    setStartOpenHour(startTime);
    setEndOpenHour(""); // Limpa o horário de término ao mudar o início
    setDurationOpenHour(0); // Reseta a duração
  };

  const novoHorario = () => {
    setIndex("");
    setIdOpenHour("");
    setDayOfWeekOpenHour("");
    setStartOpenHour("");
    setEndOpenHour("");
    setDurationOpenHour(0);
    setShowDetalhes(true);
  };

  return (
    <IonPage className="horarios-page">
      <IonHeader className="ion-no-border">
        <IonToolbar className="horarios-toolbar">
          <IonButtons slot="start">
            <IonButton aria-label="Voltar" onClick={() => history.goBack()}><IonIcon slot="icon-only" icon={arrowBack} /></IonButton>
          </IonButtons>
          <IonTitle>Horários</IonTitle>
        </IonToolbar>
        <OnboardingContextBanner />
      </IonHeader>
      <IonContent className="horarios-content">
        {podeOrdenar && <IonFab className="horarios-mobile-add" vertical="bottom" horizontal="center" slot="fixed">
          <IonFabButton color="tertiary" className="custom-fab-button" aria-label="Novo horário" onClick={novoHorario}>
            <IonIcon color="light" icon={add} aria-hidden="true" />
          </IonFabButton>
        </IonFab>}
        <main className="horarios-container">
          <header className="horarios-intro">
            <div><h1>Horários de funcionamento</h1><p>Defina os dias e períodos em que sua loja aceita pedidos.</p></div>
            <IonButton className="horarios-primary" hidden={acessos?.configuracoes != 'edicao'} onClick={novoHorario}><IonIcon icon={add} slot="start" aria-hidden="true" />Novo horário</IonButton>
          </header>
          <section className="horarios-list-card" aria-labelledby="horarios-list-title">
            <header className="horarios-list-header">
              <span className="horarios-section-icon"><IonIcon icon={timeOutline} aria-hidden="true" /></span>
              <div><h2 id="horarios-list-title">Atendimento da loja</h2><p>{listaHorarios.length} {listaHorarios.length === 1 ? 'período cadastrado' : 'períodos cadastrados'}</p></div>
            </header>
            {podeOrdenar && listaHorarios.length > 1}
            <div className={`horarios-table ${podeOrdenar ? 'horarios-table-editable' : ''}`} role={listaHorarios.length ? 'table' : undefined} aria-label="Horários de funcionamento">
              {listaHorarios.length > 0 && <div className="horarios-table-head" role="rowgroup">
                <div className="horarios-table-row" role="row">
                  {podeOrdenar && <div className="horarios-order-cell" role="columnheader" aria-label="Ordenação" />}
                  <div role="columnheader">Dia da semana</div>
                  <div role="columnheader">Início</div>
                  <div role="columnheader">Término</div>
                  {podeOrdenar && <div className="horarios-actions-heading" role="columnheader">Ações</div>}
                </div>
              </div>}
              {loadHorarios()}
            </div>
          </section>
        </main>

        <IonModal className="xeguei-dialog horarios-edit-modal" isOpen={showDetalhes} onDidDismiss={() => {
          setShowDetalhes(false);
          setIndex("");
          setIdOpenHour("");
          setDayOfWeekOpenHour("");
          setStartOpenHour("");
          setEndOpenHour("");
          setDurationOpenHour(0);
        }}>


          <div className="xeguei-dialog-panel">
            <ModalHeader title={index === "" ? "Novo horário" : "Editar horário"} subtitle="Defina o dia e o período de atendimento." icon={timeOutline} layout="compact" onDismiss={() => setShowDetalhes(false)} />
            <div className="xeguei-dialog-body horarios-form">
              <div className="horarios-field">
                <label className="horarios-field-label" id="horarios-dia-label">Dia da semana*</label>
                <IonSelect className="horarios-field-input" aria-labelledby="horarios-dia-label" interface="popover" value={dayOfWeekOpenHour} placeholder="Selecione um dia" onIonChange={e => setDayOfWeekOpenHour(e.detail.value)}>
                  <IonSelectOption value="MONDAY">Segunda-feira</IonSelectOption>
                  <IonSelectOption value="TUESDAY">Terça-feira</IonSelectOption>
                  <IonSelectOption value="WEDNESDAY">Quarta-feira</IonSelectOption>
                  <IonSelectOption value="THURSDAY">Quinta-feira</IonSelectOption>
                  <IonSelectOption value="FRIDAY">Sexta-feira</IonSelectOption>
                  <IonSelectOption value="SATURDAY">Sábado</IonSelectOption>
                  <IonSelectOption value="SUNDAY">Domingo</IonSelectOption>
                </IonSelect>
              </div>
              <div className="horarios-fields-grid">
                <div className="horarios-field">
                  <label className="horarios-field-label" id="horarios-inicio-label">Hora de início*</label>
                  <IonSelect className="horarios-field-input" aria-labelledby="horarios-inicio-label" interface="popover" value={startOpenHour} placeholder="Selecione o início" onIonChange={e => handleStartTimeChange(e.detail.value)}>
                    {generateTimeOptions2359().map(time => <IonSelectOption key={time} value={time}>{time.slice(0, 5)}</IonSelectOption>)}
                  </IonSelect>
                </div>
                <div className="horarios-field">
                  <label className="horarios-field-label" id="horarios-termino-label">Hora de término*</label>
                  <IonSelect className="horarios-field-input" aria-labelledby="horarios-termino-label" interface="popover" value={endOpenHour} placeholder={startOpenHour ? "Selecione o término" : "Escolha o início"} onIonChange={e => handleEndTimeChange(e.detail.value)} disabled={!startOpenHour}>
                    {generateEndTimeOptions().map(time => <IonSelectOption key={time} value={time}>{time.slice(0, 5)}</IonSelectOption>)}
                  </IonSelect>
                </div>
              </div>
              {durationOpenHour > 0 && <div className="horarios-info-box"><IonIcon icon={informationCircleOutline} aria-hidden="true" /><span>Duração do atendimento: {Math.floor(durationOpenHour / 60) > 0 && `${Math.floor(durationOpenHour / 60)}h `}{durationOpenHour % 60 > 0 && `${durationOpenHour % 60}min`}</span></div>}
            </div>
            <footer className="xeguei-dialog-footer horarios-form-footer">
              <button type="button" className="xeguei-modal-secondary" onClick={() => setShowDetalhes(false)}>Cancelar</button>
              <button type="button" className="xeguei-modal-primary" disabled={showLoading} onClick={() => salvar()}>Salvar horário</button>
            </footer>
          </div>

        </IonModal>

        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />

      </IonContent>

    </IonPage>
  );


};

export default Horarios;
